import cn from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'

import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'

import { containerClassName, nameClassName } from './styles'

interface Props {
   name: string
   rightEnhancer: () => React.ReactElement
   onAction: () => void
   leftEnhancer?: () => React.ReactElement
   hasDivider?: boolean
   isDeleteAction?: boolean
}

const OptionItem = (props: Props): React.ReactElement => {
   const { rightEnhancer, name, leftEnhancer, onAction, hasDivider } = props

   const { theme } = useAppTheme()
   const { option: navTheme } = theme.navbar

   const renderLeftEnhancer = (): React.ReactElement | null => {
      if (!leftEnhancer) return null

      return <div className='ml-[8px]'>{leftEnhancer()}</div>
   }

   const renderRightEnhancer = (): React.ReactElement => (
      <div className='mr-[8px]'>{rightEnhancer()}</div>
   )

   return (
      <>
         {hasDivider ? (
            <hr className={cn('mb-[2px]', navTheme.dividerColor)} />
         ) : null}
         <div
            className={cn(containerClassName, navTheme.hoverBgColor)}
            onClick={onAction}
         >
            {renderRightEnhancer()}
            <p
               className={cn(nameClassName, {
                  [navTheme.optionTextColor]: !props.isDeleteAction,
                  [navTheme.deleteActionTextColor]: props.isDeleteAction
               })}
               title={name}
            >
               {name}
            </p>
            {renderLeftEnhancer()}
         </div>
      </>
   )
}

export default observer(OptionItem)
